import { vuexHandbook } from '@/store/composition/handbook'
import { WindingTypeApi } from '@/api/handbook/position/WindingType/WindingTypeApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: WindingTypeApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
